import { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function BillingSuccess() {
  const loc = useLocation();
  const { refresh } = useAuth();
  const [status, setStatus] = useState("pending");
  const sessionId = new URLSearchParams(loc.search).get("session_id");

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let cancelled = false;
    let attempts = 0;
    const poll = async () => {
      if (cancelled) return;
      attempts++;
      if (attempts > 8) { setStatus("timeout"); return; }
      try {
        const { data } = await api.get(`/billing/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          await refresh();
          return;
        }
        if (data.status === "expired") { setStatus("expired"); return; }
        setTimeout(poll, 2000);
      } catch {
        setTimeout(poll, 2500);
      }
    };
    poll();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC] px-6">
      <div className="bg-white border border-slate-200 p-12 max-w-md text-center">
        {status === "pending" && (
          <>
            <Loader2 className="w-10 h-10 text-[#2563EB] mx-auto animate-spin" />
            <h1 className="font-display text-2xl mt-6">Validation du paiement…</h1>
            <p className="text-slate-500 text-sm mt-2">Merci de patienter quelques secondes.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 className="w-12 h-12 text-emerald-600 mx-auto" />
            <h1 className="font-display text-3xl mt-6" data-testid="billing-success-title">Bienvenue Pro !</h1>
            <p className="text-slate-600 mt-2">Votre abonnement est actif. Bonne chasse aux talents.</p>
            <Link to="/app"><Button className="mt-8 bg-[#2563EB] hover:bg-[#1D4ED8] btn-pill h-11 w-full" data-testid="billing-continue-btn">Accéder à l'app</Button></Link>
          </>
        )}
        {(status === "expired" || status === "timeout" || status === "error") && (
          <>
            <XCircle className="w-12 h-12 text-red-600 mx-auto" />
            <h1 className="font-display text-2xl mt-6">Paiement non finalisé</h1>
            <p className="text-slate-500 text-sm mt-2">La session a expiré ou est en attente. Réessayez ou contactez le support.</p>
            <Link to="/pricing"><Button className="mt-8 bg-[#0F172A] hover:bg-[#1E293B] btn-pill h-11 w-full">Retour aux tarifs</Button></Link>
          </>
        )}
      </div>
    </div>
  );
}
